var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row d-block position-relative" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-xl-6 mb-40 mb-lg-80 mb-xl-120" },
            [
              _c("h2", { staticClass: "mb-16 mt-24 mt-md-40 mt-xl-80" }, [
                _vm._v(_vm._s(_vm.contact.form.title))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-40 mb-xl-80 font-weight-light" }, [
                _vm._v(_vm._s(_vm.contact.form.description))
              ]),
              _vm._v(" "),
              _c("el-contact-form")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-12 top col-xl-5 offset-xl-7 bg-dark py-40 py-md-56 pt-xl-80 pl-xl-96 text-white position-xl-absolute h-100"
        },
        [
          _c("div", { staticClass: "px-12 px-md-24 px-xl-0" }, [
            _c("div", { staticClass: "d-none d-xl-block" }, [
              _c("div", {
                staticClass: "richtext",
                domProps: { innerHTML: _vm._s(_vm.contact.contact) }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "mb-16 d-block" }, [_vm._v("Social")]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-40" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.facebook.com/tothepointevents/",
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.svg("icon-facebook", "mr-16"))
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.instagram.com/tothepointevents",
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.svg("icon-instagram", "mr-16"))
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://twitter.com/ttpointevents",
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.svg("icon-twitter", "mr-16"))
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://www.linkedin.com/company/to-the-point-events/",
                      target: "_blank",
                      rel: "noopener"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.svg("icon-linkedin", "mr-16"))
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.contact.partner.content) }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "btn btn-accent btn-white-hover text-center mb-xl-12",
                attrs: { href: _vm.route("nl.partners") }
              },
              [
                _vm._v(_vm._s(_vm.contact.partner.button) + " "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.svg("arrow-right", "arrow-right"))
                  }
                })
              ]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }